import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SidenavOption } from '../classes';

@Injectable()
export class SidenavService {

  private _options: BehaviorSubject<SidenavOption[]> = new BehaviorSubject([]);
  options$ = this._options.asObservable();

  private _oneTimeOptions: BehaviorSubject<SidenavOption[]> = new BehaviorSubject([]);
  oneTimeOptions$ = this._oneTimeOptions.asObservable();

  private _preventOneTimeClose: BehaviorSubject<boolean> = new BehaviorSubject(false);
  preventOneTimeClose$ = this._preventOneTimeClose.asObservable();

  constructor() { }

  clearOptions(){
    this._options.next([]);
  }
  clearOneTimeOptions(){
    this._oneTimeOptions.next([]);
  }

  setOptions = (options: SidenavOption[]) => this._options.next(options);
  setOneTimeOptions = (options: SidenavOption[], preventOneTimeClose: boolean = false) => {
    this._oneTimeOptions.next(options);
    this._preventOneTimeClose.next(preventOneTimeClose === true);
  };
}
